export default "__VITE_ASSET__0SRK7jLn__"